module.exports = __webpack_public_path__ + "img/logo.4baed75d.png";